import callApi from "Common/utils/apiCaller";
import React, { useState, useEffect, useCallback } from "react";
import { toast } from "react-toastify";
import Drawer from "../Drawer";
import {
  Download,
  Plus,
  Search,
  SlidersHorizontal,
  X,
  Rows4,
  GridIcon,
} from "lucide-react";
import _ from "lodash";
import ImageView from "../ImageView/ImageView";
import { getImageUrl } from "Common/utils/ImageDomain";
import { showNotification } from "Common/utils/Notification";
import contentType from "../../../constants/contentType.json";
import ReactSelect from "../ReactSelect/ReactSelect";
import Button from "../ButtonComponent/Button";
import ImageData from "../customImage/ImageSegment";
import TwoColumnSegmentCard from "../../Components/EditableViews/TwoColumnSegmentCard";
import CustomInput from "../InputFields/CustomInput";
import ToggleSwitch from "../ToggleSwitch/ToggleSwitch";
import descriptionSegment from "../../../constants/descriptionStyle.json";

const TwoColumnSegment = ({
  pageId,
  data,
  handleDelete,
  loader,
  setLoader,
  isEditable,
  versionData,
  segmentId,
  segmentType,
  toggleVisiblity,
}) => {
  const [columData, setColumnData] = useState<any>({});
  const [imageUrl, setImageUrl] = useState("");
  const [isLoading, setIsLoading] = useState<any>(false);
  const [eventData, setEventData] = useState<any>();
  const [backgroundImage, setBackgroundImage] = useState<any>(
    data?.backgound_image
  );
  const [backgroundImageId, setBackgroundImageId] = useState<any>("");
  const [mobileBackground, setMobileBackground] = useState<any>(
    data?.mobile_background_image
  );
  const [mobileBackgroundId, setMobileBackgroundId] = useState<any>("");
  const [index, setIndex] = useState<any>(undefined);
  const [onecolumnContent, setOneColumnContent] = useState<any>();
  const [twocolumnContent, setTwoColumnContent] = useState<any>();
  const [showVideo, setShowVideo] = useState(false);
  const [errors, setErrors] = useState<any>({});

  useEffect(() => {
    if (data && data.header_text !== "") {
      setColumnData(data);
      if (data?.column_one_content_type === contentType[1].value) {
        setOneColumnContent(contentType[1]);
      } else if (data?.column_one_content_type === contentType[2].value) {
        setOneColumnContent(contentType[2]);
      }
      if (data?.column_two_content_type === contentType[1].value) {
        setTwoColumnContent(contentType[1]);
      } else if (data?.column_two_content_type === contentType[2].value) {
        setTwoColumnContent(contentType[2]);
      }
    }
  }, [data]);
  const toggle = () => {
    // setEventData(undefined);
    setShowVideo(!showVideo);
  };
  useEffect(() => {
    if (eventData && eventData.media_url) {
      //   setImageUrl(eventData?.media_url);
      if (eventData?.media_type === "image") {
        if (index === undefined) {
          if (imageUrl === "column_one_image_url") {
            handleColumnData("column_one_image_url", eventData.media_url);
            columData.column_one_image_id = eventData._id;
          } else if (imageUrl === "column_two_image_url") {
            handleColumnData("column_two_image_url", eventData.media_url);
            columData.column_two_image_id = eventData._id;
          }
        } else if (index === "background") {
          setBackgroundImage(eventData?.media_url);
          setBackgroundImageId(eventData?._id);
        } else if (index === "mobile") {
          setMobileBackground(eventData.media_url);
          setMobileBackgroundId(eventData._id);
          setErrors((prev) => ({ ...prev, ["mobile_background_image"]: "" }));
        }
      } else {
        showNotification("Media type should be image", "error");
      }
    }
  }, [eventData, imageUrl, index]);

  const handleColumnData = (keyName, keyValue) => {
    if (keyName === "column_one_content_type") {
      // setContent(keyValue.value)
      setOneColumnContent(keyValue);
      if (keyValue.value === "Select...") {
        setColumnData((prev) => ({ ...prev, [keyName]: "" }));
      } else {
        if (keyValue.value === "text") {
          setColumnData((prev) => ({ ...prev, ["column_one_image_url"]: "" }));
          setColumnData((prev) => ({ ...prev, ["column_one_image_id"]: "" }));
          setColumnData((prev) => ({ ...prev, [keyName]: keyValue.value }));
        } else {
          setColumnData((prev) => ({ ...prev, ["column_one_text"]: "" }));
          setColumnData((prev) => ({ ...prev, [keyName]: keyValue.value }));
        }
      }
    } else if (keyName === "column_two_content_type") {
      setTwoColumnContent(keyValue);
      if (keyValue.value === "Select...") {
        setColumnData((prev) => ({ ...prev, [keyName]: "" }));
      } else {
        if (keyValue.value === "text") {
          setColumnData((prev) => ({ ...prev, ["column_two_image_url"]: "" }));
          setColumnData((prev) => ({ ...prev, ["column_two_image_id"]: "" }));
          setColumnData((prev) => ({ ...prev, [keyName]: keyValue.value }));
        } else {
          setColumnData((prev) => ({ ...prev, ["column_two_text"]: "" }));
          setColumnData((prev) => ({ ...prev, [keyName]: keyValue.value }));
        }
      }
    } else {
      setColumnData((prev) => ({ ...prev, [keyName]: keyValue }));
    }
    setErrors((prev) => ({ ...prev, [keyName]: "" }));
  };

  const handleValidation = (data) => {
    let isValid = true;
    let errors = {};
    if (!!!data.header_text || data.header_text === "") {
      errors["header_text"] = "Please enter header text";
      isValid = false;
    }
    if (
      !!!data.column_one_content_type ||
      data.column_one_content_type === ""
    ) {
      errors["column_one_content_type"] =
        "Please enter column one content type";
      isValid = false;
    }
    if (
      !!!data.column_two_content_type ||
      data.column_two_content_type === ""
    ) {
      errors["column_two_content_type"] =
        "Please enter column two content type";
      isValid = false;
    }
    // if (!!!data.column_one_text || data.column_one_text === "") {
    //   errors["column_one_text"] = "Please enter column one text";
    //   isValid = false;
    // }
    // if (!!!data.column_two_text || data.column_two_text === "") {
    //   errors["column_two_text"] = "Please enter column two text";
    //   isValid = false;
    // }
    // if (!!!data.column_two_image_url || data.column_two_image_url === "") {
    //   errors["column_two_image_url"] = "Please enter column two image url";
    //   isValid = false;
    // }
    // if (!!!data.column_one_image_url || data.column_one_image_url === "") {
    //   errors["column_one_image_url"] = "Please enter column one image url";
    //   isValid = false;
    // }
    return {
      isValid,
      errors,
    };
  };
  const handleErrors = (errors) => {
    setErrors(errors);
  };
  const showError = (keyName) => {
    return errors && errors[keyName] ? (
      <p className="text-red-500 text-[14px]  pt-2">{errors[keyName]}</p>
    ) : null;
  };

  const handleSave = async (pageId, id) => {
    let check = handleValidation(columData);

    const payload = {
      segment_type: "twocolumn_segments",
      ...columData,
      

      background_image: (backgroundImage === null || backgroundImage == undefined) ? "" : backgroundImage,
        background_image_id: (backgroundImage === null || backgroundImage == undefined) ? "" : backgroundImageId,
        mobile_background_image_id: (mobileBackground === null || mobileBackground == undefined) ? "" : mobileBackgroundId,
        mobile_background_image: (mobileBackground === null || mobileBackground == undefined) ? "" : mobileBackground
    };

    try {
      if (check.isValid) {
        setIsLoading(true);
        const response = await callApi(
          `v1/page/${pageId}/segment/${id}/update-info`,
          "post",
          payload
        );
        setIsLoading(false);
        if (response && response?.status === "Success") {
          setLoader(!loader);
          showNotification("Two column segment added successfully!", "success");
        } else {
          showNotification("Something went wrong. Please try again.", "error");
        }
      } else {
        handleErrors(check.errors);
      }
    } catch (e) {
      showNotification("An error occurred . Please try again.", "error");
      setIsLoading(false);
    }
  };

  const handleStyleData = (keyName, keyValue) => {
    if (keyValue.value === "Select...") {
    } else {
      handleColumnData("style", keyValue.value);
    }
  };

  return (
    <>
      <div className="bg-white border border-black-600 rounded-[5px] px-8 py-4">
        <div>
          <ToggleSwitch
            selectValue={data?.is_visible}
            versionValue={versionData?.is_visible}
            toggle={() =>
              toggleVisiblity(pageId, segmentId, segmentType, !data?.is_visible)
            }
            label="Is Segment Visible?"
            required={true}
          />
          <div className="flex my-4">
            {backgroundImage ? (
              <div className="flex items-center">
                <ImageData
                  imageLink={backgroundImage}
                  setImageData={setEventData}
                  setImageLink={setBackgroundImage}
                />
                <div className="h-3 ml-3">
                  <button
                    onClick={() => {
                      toggle();
                      setIndex("background");
                      setEventData(undefined);
                    }}
                    className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
                  >
                    Change
                  </button>
                </div>
              </div>
            ) : (
              <button
                onClick={() => {
                  toggle();
                  setIndex("background");
                  setEventData(undefined);
                }}
                className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
              >
                Add BackgroundImage
              </button>
            )}
          </div>
          {/* {errors.image_url && (
            <p className="text-sm text-red-500">{errors.image_url}</p>
          )} */}
        </div>
        <div>
          <div className="flex my-4">
            {mobileBackground ? (
              <div className="flex items-center">
                <ImageData
                  imageLink={mobileBackground}
                  setImageData={setEventData}
                  setImageLink={setMobileBackground}
                />
                <div className="h-3 ml-3">
                  <button
                    onClick={() => {
                      toggle();
                      setIndex("mobile");
                      setEventData(undefined);
                    }}
                    className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
                  >
                    Change
                  </button>
                </div>
              </div>
            ) : (
              <button
                onClick={() => {
                  toggle();
                  setIndex("mobile");
                  setEventData(undefined);
                }}
                className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
              >
                Add MobileBackground
              </button>
            )}
          </div>
        </div>
        <div className="mb-4 xl:col-span-12">
          <CustomInput
            label="Header Text"
            name="imageAlt"
            type="text"
            placeholder="Enter Header Text"
            value={columData.header_text}
            onChange={(e) => handleColumnData("header_text", e.target.value)}
            isVersioned={versionData ? true : false}
            versionedValue={versionData?.header_text}
            error={errors?.header_text}
          />
        </div>
        <div className="mb-4 xl:col-span-6">
          <label className="inline-block mb-2 text-base font-medium">
            Style
          </label>
          <ReactSelect
            options={descriptionSegment}
            isSearchable={false}
            isMulti={false}
            placeholder={"Please select style type"}
            contentType={{ value: columData.style, label: columData.style }}
            handleContentChange={handleStyleData}
            name={"style"}
            id={"style-type5"}
            versionData={
              versionData?.style
                ? {
                    label: versionData?.style,
                    value: versionData?.style,
                  }
                : null
            }
          />
        </div>
        {/* <div className="my-4 xl:col-span-12">
          <CustomInput
            label="Style"
            name="imageAlt"
            type="text"
            placeholder="Enter  style"
            value={columData.style}
            onChange={(e) => handleColumnData("style", e.target.value)}
            isVersioned={versionData ? true : false}
            versionedValue={versionData?.style}
            error={errors?.style}
          />
        </div> */}
        {versionData ? (
          <div className="grid grid-cols-1 gap-4 mb-2 xl:grid-cols-12">
            Old Data
          </div>
        ) : null}
        {versionData ? (
          <div className="grid grid-cols-1 gap-4 xl:grid-cols-12">
            <div className=" xl:col-span-6">
              <TwoColumnSegmentCard
                cardLabel={"Column One Content Type"}
                contentType={contentType}
                singleColumnData={
                  versionData.column_one_content_type === "text"
                    ? contentType[1]
                    : contentType[2]
                }
                columnData={versionData}
                handleColumnData={handleColumnData}
                showError={showError}
                setColumnData={setColumnData}
                setEventData={setEventData}
                setImageUrl={setImageUrl}
                setIndex={setIndex}
                columnLabel={"Column One Text"}
                dropdownKeyName={"column_one_content_type"}
                textKey={"column_one_text"}
                imageKey={"column_one_image_url"}
                toggle={toggle}
                isEditable={false}
              />
            </div>
            <div className=" xl:col-span-6">
              <TwoColumnSegmentCard
                cardLabel={"Column two Content Type"}
                contentType={contentType}
                singleColumnData={
                  versionData.column_two_content_type === "text"
                    ? contentType[1]
                    : contentType[2]
                }
                columnData={versionData}
                handleColumnData={handleColumnData}
                showError={showError}
                setColumnData={setColumnData}
                setEventData={setEventData}
                setImageUrl={setImageUrl}
                setIndex={setIndex}
                columnLabel={"Column One Text"}
                dropdownKeyName={"column_two_content_type"}
                textKey={"column_two_text"}
                imageKey={"column_two_image_url"}
                toggle={toggle}
                isEditable={false}
              />
            </div>
          </div>
        ) : null}
        {versionData ? (
          <div className="grid grid-cols-1 gap-4 mt-2 mb-2 xl:grid-cols-12">
            New Data
          </div>
        ) : null}
        <div className="grid grid-cols-1 gap-4 xl:grid-cols-12">
          <div className=" xl:col-span-6">
            <TwoColumnSegmentCard
              cardLabel={"Column One Content Type"}
              contentType={contentType}
              singleColumnData={onecolumnContent}
              columnData={columData}
              handleColumnData={handleColumnData}
              showError={showError}
              setColumnData={setColumnData}
              setEventData={setEventData}
              setImageUrl={setImageUrl}
              setIndex={setIndex}
              columnLabel={"Column One Text"}
              dropdownKeyName={"column_one_content_type"}
              textKey={"column_one_text"}
              imageKey={"column_one_image_url"}
              toggle={toggle}
              isEditable={isEditable}
            />
          </div>
          <div className=" xl:col-span-6">
            <TwoColumnSegmentCard
              cardLabel={"Column two Content Type"}
              contentType={contentType}
              singleColumnData={twocolumnContent}
              columnData={columData}
              handleColumnData={handleColumnData}
              showError={showError}
              setColumnData={setColumnData}
              setEventData={setEventData}
              setImageUrl={setImageUrl}
              setIndex={setIndex}
              columnLabel={"Column One Text"}
              dropdownKeyName={"column_two_content_type"}
              textKey={"column_two_text"}
              imageKey={"column_two_image_url"}
              toggle={toggle}
              isEditable={isEditable}
            />
          </div>
        </div>

        {/* Save Button */}
        <div className="flex justify-end gap-2 mt-4">
          <Button
            isLoading={isLoading}
            handleSave={handleSave}
            pageId={pageId}
            id={segmentId}
          />

          <button
            className="text-red-500 bg-white btn hover:text-red-500 hover:bg-red-100 focus:text-red-500 focus:bg-red-100 active:text-red-500 active:bg-red-100 dark:bg-zink-600 dark:hover:bg-red-500/10 dark:focus:bg-red-500/10 dark:active:bg-red-500/10"
            onClick={() => handleDelete(segmentId, data?.segment_type)}
          >
            Delete
          </button>
        </div>
      </div>
      <Drawer
        show={showVideo}
        onHide={toggle}
        id="drawerEnd"
        drawer-end="true"
        className="fixed inset-y-0 flex flex-col w-1/2 transition-transform duration-300 ease-in-out transform bg-white shadow ltr:right-0 rtl:left-0 z-drawer dark:bg-zink-600"
      >
        <Drawer.Header
          className="flex items-center justify-between p-4 border-b card-body border-slate-200 dark:border-zink-500"
          closeButtonClass="lucide lucide-x size-4 transition-all duration-200 ease-linear text-slate-500 hover:text-slate-700 dark:text-zink-200 dark:hover:text-zink-50"
        >
          <Drawer.Title className="text-15">{"Select Video"}</Drawer.Title>
          <X className="transition-all duration-200 ease-linear size-4 text-slate-500 hover:text-slate-700 dark:text-zink-200 dark:hover:text-zink-50"></X>
        </Drawer.Header>
        <Drawer.Body className="h-full p-4 overflow-y-auto">
          <ImageView
            showImage={showVideo}
            setEventData={setEventData}
            togleImage={toggle}
          />
        </Drawer.Body>
      </Drawer>
    </>
  );
};

export default TwoColumnSegment;
